export const COMMON_ALERT_DIALOG_CONST = {
  save: '작성된 내용을 등록하시겠어요?',
  edit: '수정된 내용을 저장하시겠어요?',
  delete: '작성된 내용을 삭제하시겠어요?',
};
